import React, { PropTypes } from 'react';
import R from 'ramda';

const FileName = props => {
  const {
    fileName,
    vertical,
    width,
    fileNameStyle,
  } = props;

  return (
    <div style={{
      height: '24px',
      width: width || '145px',
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'center',
      marginLeft: vertical ? '' : '3px',
    }}
    >
      <span style={R.merge({ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }, fileNameStyle)}>
        {fileName}
      </span>
    </div>
  );
};

FileName.propTypes = {
  fileName: PropTypes.string,
  width: PropTypes.string,
  vertical: PropTypes.bool,
  fileNameStyle: PropTypes.object,
};

export default FileName;



// WEBPACK FOOTER //
// ./src/app/components/extra/filePreview/fileName.jsx